import { render, staticRenderFns } from "./CmsContent.vue?vue&type=template&id=470db38a&scoped=true&"
import script from "./CmsContent.vue?vue&type=script&lang=ts&"
export * from "./CmsContent.vue?vue&type=script&lang=ts&"
import style0 from "./CmsContent.vue?vue&type=style&index=0&id=470db38a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470db38a",
  null
  
)

export default component.exports